// src/Components/DashboardCard.js 
import React from "react";

const DashboardCard = ({ icon, title, value, lastUpdate, index }) => {
  return (
    <div
      className={`
        bg-grayish rounded-2xl p-6 flex flex-col justify-between shadow-md
        transition-all duration-500 ease-out
        border border-grayish
        opacity-0 translate-y-6
        animate-fadeSlideUp
      `}
      style={{ animationDelay: `${index * 150}ms` }}
    >
      {/* الأيقونة */}
      <div className="flex items-center justify-start">
        <div className="bg-main1/20 p-3 rounded-full">
          <span className="text-main1 text-lg">{icon}</span>
        </div>
      </div>

      {/* القيمة والعنوان */}
      <div className="mt-4">
        <p className="text-main1 font-bold text-2xl">{value}</p>
        <p className="text-gray-500 text-sm mt-1">{title}</p>
      </div>

      {/* آخر تحديث */}
      <p className="text-xs text-main1 mt-4 ">
        آخر تحديث:  {lastUpdate}
      </p>
    </div>
  );
};

export default DashboardCard;
